import * as constent from "../constent";
import useAlertStore from "store/alert";
import useAuthStore from "store/auth";

export const regEmail =
  /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}?/;
export const regPhone = /^01([0|1|6|7|8|9]?)([0-9]{3,4})([0-9]{4})$/;
// 영문 + 숫자 + 특수 문자
export const regPwd = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,20}/;

// export const regId = /^[a-zA-Z][a-zA-Z0-9]*$/;
export const regEN = /^[a-zA-Z]*$/;
export const regNum = /^[0-9]*$/;

export const uploadFileSizeInMB = 1;
export const getImgSizeInMB = (size: number) => {
  return Number((size / (1024 * 1024)).toFixed(2));
};

// 전화번호 마스킹
export const maskPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
};

export const all = {
  ko: "전체",
  en: "Select",
  code: "",
  value: "",
};

export const initialSelectData = {
  ko: "전체",
  en: "Select",
  code: "",
  value: "",
};

export const Interval = 14;
const pageRows = 10;
export const pageInitInf = {
  pageNo: 1,
  pageRows: pageRows,
  // pageSize: 10,
  // pageBlock: Math.ceil(pageRows / 10),
};

export const initialPageNav = {
  backPage: 0,
  backPageUnit: 0,
  beginUnitPage: 0,
  endUnitPage: 0,
  nextPage: 0,
  nextPageUnit: 0,
  pageNo: 0,
  pageRows: 0,
  pageUnit: 0,
  totalPage: 0,
  totalRows: 0,
};

// api 실패했을시
export const apifield = (message: string) => {
  const { onSetAlert } = useAlertStore.getState();
  onSetAlert({
    isOpen: true,
    inner: message,
  });
};

// 수정페이지 폼 수정여부 체크
type IIsUpdatedProps = {
  form: HTMLFormElement;
};
export const updated = ({ form }: IIsUpdatedProps) => {
  const { onSetAlert } = useAlertStore.getState();
  /**
   * 현재 폼에 있는 input, editor, select에 변경된 값이 있는지 체크
   * input, textarea data-type="U"가 잇는지 확인
   * 있으면 true, 없으면 false
   * false 일때 알림:"수정된 내용이 없습니다."
   *
   */
  const inputs = form.querySelectorAll(
    `input[data-type="U"]`
  ) as NodeListOf<HTMLInputElement>;

  const editorEl = form.querySelector(
    `textarea.editor-textarea[data-type="U"]`
  ) as HTMLDivElement;

  const isUpdated = inputs.length !== 0 || editorEl;

  if (!isUpdated) {
    onSetAlert({
      isOpen: true,
      inner: "수정된 내용이 없습니다.",
    });

    return false;
  }

  if (isUpdated) {
    return true;
  }
};

type CalendarDate = {
  date: Date;
  fullDate: string;
  dateSt: string;
  day: number;
  isCurrentMonth: boolean;
  isToday: boolean;
};

export const getKoreanCalendarDates = (baseDate: Date): CalendarDate[] => {
  // 🔑 baseDate도 로컬 기준으로 보정
  const year = baseDate.getFullYear();
  const month = baseDate.getMonth();

  // 오늘 (KST 기준, 시/분/초 제거)
  const today = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  );

  // 이번 달 1일 (KST 00:00)
  const firstDayOfMonth = new Date(year, month, 1);

  // 요일 (0: 일요일 ~ 6: 토요일)
  const dayOfWeek = firstDayOfMonth.getDay();

  // 달력 시작일 (일요일)
  const calendarStartDate = new Date(year, month, 1 - dayOfWeek);

  const dates: CalendarDate[] = [];

  for (let i = 0; i < 42; i++) {
    // 👉 항상 "year, month, day" 생성 (시간 밀림 방지)
    const date = new Date(
      calendarStartDate.getFullYear(),
      calendarStartDate.getMonth(),
      calendarStartDate.getDate() + i
    );

    const isToday =
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate();

    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");

    dates.push({
      date,
      fullDate: `${y}${m}${d}`,
      dateSt: date.getDate() + "",
      day: date.getDay(),
      isCurrentMonth: date.getMonth() === month,
      isToday,
    });
  }

  return dates;
};

/****************** SET FORM CREATE READ UPDATE *************/

type IForm = {
  form: HTMLFormElement;
};
export const setFormCreateTyp = ({ form }: IForm) => {
  if (form) {
    const inputs = form.querySelectorAll(
      "input"
    ) as NodeListOf<HTMLInputElement>;

    Array.from(inputs).forEach((input: HTMLInputElement) => {
      if (input.disabled) {
        return;
      }
      if (input.type === "radio") {
        // input.id = input.id + "_M_" + "_C";
        input.id = `${input.id}_M__C`;
        const label = input.nextSibling as HTMLLabelElement;
        label.htmlFor = input.id;
        input.setAttribute("data-type", "C");
        return;
      }
      if (input.type === "checkbox") {
        // input.id = input.id + "_M_" + "_C";
        input.id = `${input.id}_M__C`;

        const label = input.nextSibling as HTMLLabelElement;
        label.htmlFor = input.id;
        input.setAttribute("data-type", "C");
        return;
      }
      if (input.type === "text") {
        input.setAttribute("data-type", "C");
        return;
      }
    });

    const labelDot = form.querySelectorAll(
      'label[for="dot"]'
    ) as NodeListOf<HTMLLabelElement>;

    if (labelDot) {
      Array.from(labelDot).forEach((label: HTMLLabelElement) => {
        label.className = "text-red-500";
      });
    }

    const selects = form.querySelectorAll(
      'div[role="listboxselect"]'
    ) as NodeListOf<HTMLDivElement>;
    if (selects) {
      Array.from(selects).forEach((select: HTMLDivElement) => {
        select.setAttribute("data-type", "C");
      });
    }
    const editor = form.querySelector("div.editor-wrap") as HTMLDivElement;
    if (editor) {
      editor.setAttribute("data-type", "C");
    }
  }
};

export const setFormReadTyp = ({ form }: IForm) => {
  if (form) {
    const inputs = form.querySelectorAll(
      "input"
    ) as NodeListOf<HTMLInputElement>;

    if (inputs) {
      Array.from(inputs).map((input: HTMLInputElement) => {
        return input.setAttribute("data-type", "R");
      });
    }
    const selects = form.querySelectorAll(
      'div[role="listbox"]'
    ) as NodeListOf<HTMLDivElement>;
    if (selects) {
      Array.from(selects).forEach((select: HTMLDivElement) => {
        select.setAttribute("data-type", "R");
      });
    }
    const editor = form.querySelector("div.editor-wrap") as HTMLDivElement;
    if (editor) {
      editor.setAttribute("data-type", "R");
    }
  }
};

export const setFormUpdateTyp = ({ form }: IForm) => {
  if (form) {
    const inputs = form.querySelectorAll(
      "input"
    ) as NodeListOf<HTMLInputElement>;

    Array.from(inputs).forEach((input: HTMLInputElement) => {
      const { update } = input.dataset;
      if (input.disabled || update === "false") {
        input.setAttribute("data-type", "R");
        input.readOnly = true;
        return;
      }
      if (input.type === "radio") {
        // input.id = input.id + "_M_" + "_C";
        input.id = `${input.id}_M__C`;
        const label = input.nextSibling as HTMLLabelElement;
        label.htmlFor = input.id;
        input.setAttribute("data-type", "C");
        input.setAttribute("data-update", "true");
        label.setAttribute("data-update", "true");
        return;
      }
      if (input.type === "checkbox") {
        // input.id = input.id + "_M_" + "_C";
        input.id = `${input.id}_M__C`;

        const label = input.nextSibling as HTMLLabelElement;
        label.htmlFor = input.id;
        input.setAttribute("data-type", "C");
        input.setAttribute("data-update", "true");
        label.setAttribute("data-update", "true");
        return;
      }
      if (input.type === "text") {
        input.setAttribute("data-type", "C");
        input.setAttribute("data-update", "true");
        return;
      }
    });

    const selects = form.querySelectorAll(
      'div[role="listbox"], div[role="phone"]'
    ) as NodeListOf<HTMLDivElement>;
    if (selects) {
      Array.from(selects).forEach((select: HTMLDivElement) => {
        select.setAttribute("data-type", "C");
        select.setAttribute("data-update", "true");
      });
    }
    const editor = form.querySelector("div.editor-wrap") as HTMLDivElement;
    if (editor) {
      editor.setAttribute("data-type", "C");
      editor.setAttribute("data-update", "true");
    }
  }
};

// 업데이트 된 폼 초기화
export const resetUpdateTyp = ({ form }: IForm) => {
  if (form) {
    const inputs = form.querySelectorAll(
      "input"
    ) as NodeListOf<HTMLInputElement>;

    Array.from(inputs).forEach((input: HTMLInputElement) => {
      const { type } = input.dataset;
      if (type !== "U") {
        return;
      }
      if (type === "U") {
        input.setAttribute("data-type", "C");
        input.setAttribute("data-update", "true");
      }
    });
  }
};

export const resetInput = ({ form }: IForm) => {
  if (form) {
    const inputs = form.querySelectorAll(
      "[data-type='C']"
    ) as NodeListOf<HTMLInputElement>;
    setTimeout(() => {
      Array.from(inputs).forEach((input: HTMLInputElement) => {
        if (input.name !== "langCd") {
          input.value = "";
          return;
        }
      });
      resetEditor();
    }, 5);
    return;
  }
};

export const setIsUpdate = ({ form }: IForm) => {
  if (form) {
    const types = form.querySelectorAll("[data-type='C']") as NodeListOf<
      HTMLInputElement | HTMLDivElement
    >;
    setTimeout(() => {
      Array.from(types).forEach((type: HTMLInputElement | HTMLDivElement) => {
        type.setAttribute("data-update", "true");
      });
    }, 10);
    const labelDot = form.querySelectorAll(
      'label[for="dot"]'
    ) as NodeListOf<HTMLLabelElement>;
    if (labelDot) {
      labelDot.forEach((label: HTMLLabelElement) => {
        const useStyles = Array.from(label.classList).filter((style) => {
          return !style.includes("text-red-500");
        });
        label.className = useStyles.join(" ");
      });
    }
    const editor = form.querySelector("div.editor-wrap") as HTMLDivElement;
    editor.setAttribute("data-update", "true");
  }
  // }
};

// export const setLang

/*********************GET FORM DATA **************/
type IFormData = {
  event?: React.MouseEvent<HTMLButtonElement>;
  form: HTMLFormElement;
  type: "C" | "U";
};
export const getFormData = ({ event, form, type }: IFormData) => {
  if (event) {
    event.preventDefault();
  }
  let params = {} as any;
  let radio = {};
  let checkbox = {};
  let text = {};
  let editor = {};
  if (form) {
    const inputs = form.querySelectorAll(
      `input[data-type=${type}]`
    ) as NodeListOf<HTMLInputElement>;
    Array.from(inputs).forEach((input: HTMLInputElement) => {
      const name = input.name;
      const value = input.value;
      const type = input.type;
      const checked = input.checked;

      if (!!name) {
        if (type === "radio" && checked) {
          const { value } = input.dataset;
          const radioNm = input.name.replaceAll("-S", "");
          radio = {
            ...radio,
            [radioNm]: value,
          };
        }
        if (type === "checkbox") {
          checkbox = {
            ...checkbox,
            [name]: input.checked ? "Y" : "N",
          };
        }
        if (type === "text" || type === "password") {
          text = {
            ...text,
            [name]: name.includes("Dt")
              ? value.replaceAll("-", "")
              : name.includes("Pri")
              ? value.replaceAll(",", "")
              : name.includes("Ti")
              ? value.replaceAll(":", "")
              : value,
          };
        }
      }
    });

    //에디터
    const editorEl = form.querySelector(
      `textarea.editor-textarea[data-type=${type}]`
    ) as HTMLTextAreaElement;

    // if (!editorEl) return;
    if (editorEl) {
      const value = editorEl.value;

      editor = {
        ...editor,
        [editorEl.name]: value,
      };
    }
    //필수입력

    params = {
      ...params,
      ...radio,
      ...checkbox,
      ...text,
      ...editor,
    };

    return params;
  }
};

/********************  FORMATTER        *************/

export const formatYYYYMMDD = (date: Date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");

  return `${y}${m}${d}`;
};

export const dateFormat = (date: string, sign = "-") => {
  const format = date?.replace(
    /^(\d{0,4})(\d{0,2})(\d{0,2})$/g,
    `$1${sign}$2${sign}$3`
  );
  return format;
};

type IPriceFormat = {
  price: string | number;
  payLangCd?: string;
  currSymbol?: boolean;
};

export const priceFormat = ({
  price,
  payLangCd,
  currSymbol = true,
}: IPriceFormat) => {
  if (!!price) {
    if (payLangCd === "KR") {
      return (
        (currSymbol ? "₩" : "") +
        (price + "")?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    }
    if (payLangCd === "EN") {
      return (
        (currSymbol ? "$" : "") +
        (price + "")?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    }
    if (payLangCd === "JP") {
      return (
        (currSymbol ? "¥" : "") +
        (price + "")?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    }
    if (payLangCd === "none") {
      return (price + "")?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return (
      (currSymbol ? "₩" : "") +
      (price + "")?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );
  }
  if (!price) {
    return 0;
  }
};

export const isEmpty = (params: any) => {
  return Object.values(params).length === 0;
};

export const timeFormat = (time: string | number) => {
  return (time + "").replace(/\B(?=(\d{2})+(?!\d))/g, ":") || "-";
};
export const maskEmail = (emlId: string) => {
  const [id, domain] = emlId.split("@");
  if (id.length <= 2) return "*".repeat(id.length) + "@" + domain;

  const visible = id.slice(0, 2);
  const masked = "*".repeat(id.length - 2);
  return `${visible}${masked}@${domain}`;
};

/**************** GET  DATE  **************/

export const afterDay = (diff: number) => {
  const now = new Date().toISOString();
  const year = new Date().getFullYear();
  const month = new Date().getMonth();
  const day = new Date().getDate();

  let sDt = now.split("T")[0].replaceAll("-", "");
  let eDt = new Date(year, month, day + diff)
    .toISOString()
    .split("T")[0]
    .replaceAll("-", "");

  return {
    sDt,
    eDt,
    // sDt: sDt?.replace(/^(\d{0,4})(\d{0,2})(\d{0,2})$/g, `$1${"-"}$2${"-"}$3`),
    // eDt: eDt?.replace(/^(\d{0,4})(\d{0,2})(\d{0,2})$/g, `$1${"-"}$2${"-"}$3`),
  };
};

// 요일
export const getDay = ({
  dayNm,
  date,
  langCd,
}: {
  dayNm?: string | number;
  date?: string | number;
  langCd: string;
}) => {
  let day = dayNm;
  if (!dayNm && date) {
    day =
      date.toString().length > 1
        ? new Date(dateFormat(date + "" ?? "")).getDay()
        : date;
  }

  if (langCd === "ko") {
    switch (day + "") {
      case "0":
        return "일요일";
      case "1":
        return "월요일";
      case "2":
        return "화요일";
      case "3":
        return "수요일";
      case "4":
        return "목요일";
      case "5":
        return "금요일";
      case "6":
        return "토요일";

      case "7":
        return "일요일";
    }
  }
  if (langCd === "en") {
    switch (day + "") {
      case "0":
        return "SUM";
      case "1":
        return "MON";
      case "2":
        return "TUE";
      case "3":
        return "WED";
      case "4":
        return "THU";
      case "5":
        return "FRI";
      case "6":
        return "SAT";
      case "7":
        return "SUM";
    }
  }
};

/****************** GRID DISPATCH DATA   *****************/

export const gridCellChanged = (props: any) => {
  const gridCellChangedEvent = new CustomEvent(
    constent.CONST_COMN_GRID_CELL_CHANGED,
    {
      detail: props,
    }
  );
  window.dispatchEvent(gridCellChangedEvent);
};

/************. GRID FORMATTER ********** */
export function dateFormatter(params: any) {
  return dateFormat(params.value, "-");
}

export function priceFormatter(params: any) {
  return priceFormat({ price: params.value });
}

export const getToday = () => {
  const now = new Date();
  // 한국 시간대(Asia/Seoul) 기준
  const formatter = new Intl.DateTimeFormat("ko-KR", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const parts = formatter.formatToParts(now) as any[];
  const y = parts.find((p) => p.type === "year").value;
  const m = parts.find((p) => p.type === "month").value;
  const d = parts.find((p) => p.type === "day").value;

  const today = `${y}${m}${d}`;

  return today;
};

/***********************  ***************** */

export const timeout = () => {
  const { setIsLogin } = useAuthStore.getState();
  localStorage.removeItem("pages");
  localStorage.removeItem("lodGrpInf");
  localStorage.removeItem("mdi-storage");
  localStorage.removeItem("lod-storage");
  localStorage.removeItem("lodList-storage");
  localStorage.removeItem("lodGrp-storage");
  localStorage.removeItem("user-storage");
  localStorage.removeItem("pageNo-storage");
  window.location.replace("/");

  setIsLogin(false);

  const useSettimeoutEvent = new CustomEvent(
    constent.CONST_COMN_SESSION_SETTIME_OUT,
    {
      detail: false,
    }
  );

  window.dispatchEvent(useSettimeoutEvent);
  // };

  // return {
  //   timeout,
  // };
};

export const uploadImgPops = (props: any) => {
  const uploadImgDataEvent = new CustomEvent(
    constent.CONST_COMN_UPLOAD_IMG_DATA,
    {
      detail: props,
    }
  );

  window.dispatchEvent(uploadImgDataEvent);
};

export const resetEditor = () => {
  const resetEvent = new CustomEvent(constent.CONST_COMN_RESET_EDITOR, {
    detail: "",
  });

  window.dispatchEvent(resetEvent);
};
